import { useCallback } from 'react';
import { logger } from '../utils/logger';

export interface ContactData {
  Name?: string;
  Phone?: string;
  Email?: string;
}

export const useContactExtraction = () => {
  const extractContactData = useCallback((submittedFormData: { [key: string]: string }): ContactData => {
    logger.log('🔥 === EXTRACTING CONTACT DATA ===');
    
    const contactData: ContactData = {};
    
    // Check if this is a structured form submission (like from FinanceForm)
    let sourceData = submittedFormData;
    
    // If there's a formData property, use that as the source
    if ((submittedFormData as any).formData) {
      sourceData = (submittedFormData as any).formData;
    }
    
    // Extract contact information from the source data
    if (sourceData.name || submittedFormData.name) {
      contactData.Name = sourceData.name || submittedFormData.name;
    }
    if (sourceData.phone || submittedFormData.phone) {
      contactData.Phone = sourceData.phone || submittedFormData.phone;
    }
    if (sourceData.email || submittedFormData.email) {
      contactData.Email = sourceData.email || submittedFormData.email;
    }
    
    return contactData;
  }, []);

  const hasValidContactData = useCallback((contactData: ContactData): boolean => {
    return Object.keys(contactData).length > 0 && 
           (!!contactData.Name || !!contactData.Phone || !!contactData.Email);
  }, []);

  return {
    extractContactData,
    hasValidContactData
  };
};